export default "__VITE_ASSET__CAn0YT8o__"